import { useMemo, useState } from 'react'

import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

const INITIAL_STATE = {
  clientes: [],
  clienteFilter: '',
  errorMessage: null,
  loadingMessage: null,
  modalNotas: { show: false, cliente: null, deliveries: [] },
  modalEtiquetas: { show: false, cliente: null, etiquetas: [] },
}

const SELECT_TP_MESSAGE = 'Selecione um TP para buscar'

export default function useRelatorioPosicoesEtiquetasCliente() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      async getRelatorio(selectedTp) {
        if (!Number(selectedTp)) {
          setState(prev => ({
            ...prev,
            clientes: [],
            errorMessage: SELECT_TP_MESSAGE,
          }))
          return
        }

        setState(prev => ({
          ...prev,
          clientes: [],
          loadingMessage: 'Buscando relatório...',
        }))

        EstoqueHttp.getRelatorioPosicoesEtiquetasCliente(selectedTp)
          .then(response =>
            setState(prev => ({
              ...prev,
              clientes: response.clientes || [],
              loadingMessage: null,
            })),
          )
          .catch(error =>
            setState(prev => ({
              ...prev,
              loadingMessage: null,
              errorMessage: errorHandler(error),
            })),
          )
      },

      resetState() {
        setState(prev => ({ ...prev, errorMessage: null, loadingMessage: null }))
      },

      onClienteFilterChange(value) {
        setState(prev => ({ ...prev, clienteFilter: value }))
      },

      onQtdNfClicked(cliente, selectedTp) {
        if (!Number(selectedTp)) {
          setState(prev => ({ ...prev, errorMessage: SELECT_TP_MESSAGE }))
          return
        }

        setState(prev => ({
          ...prev,
          loadingMessage: 'Buscando etiquetas por nota...',
          modalNotas: { show: false, cliente, deliveries: [] },
        }))

        EstoqueHttp.getRelatorioPosicoesEtiquetasClienteNotas(selectedTp, cliente.client_id)
          .then(response =>
            setState(prev => ({
              ...prev,
              loadingMessage: null,
              modalNotas: {
                show: true,
                cliente: { ...cliente, cliente: response.cliente || cliente.cliente },
                deliveries: response.deliveries || [],
              },
            })),
          )
          .catch(error =>
            setState(prev => ({
              ...prev,
              loadingMessage: null,
              errorMessage: errorHandler(error),
            })),
          )
      },

      onQtdEtiquetasClicked(cliente, selectedTp) {
        if (!Number(selectedTp)) {
          setState(prev => ({ ...prev, errorMessage: SELECT_TP_MESSAGE }))
          return
        }

        setState(prev => ({
          ...prev,
          loadingMessage: 'Buscando etiquetas por cliente...',
          modalEtiquetas: { show: false, cliente, etiquetas: [] },
        }))

        EstoqueHttp.getRelatorioPosicoesEtiquetasClienteEtiquetas(selectedTp, cliente.client_id)
          .then(response =>
            setState(prev => ({
              ...prev,
              loadingMessage: null,
              modalEtiquetas: {
                show: true,
                cliente: { ...cliente, cliente: response.cliente || cliente.cliente },
                etiquetas: response.etiquetas || [],
              },
            })),
          )
          .catch(error =>
            setState(prev => ({
              ...prev,
              loadingMessage: null,
              errorMessage: errorHandler(error),
            })),
          )
      },

      onModalNotasClose() {
        setState(prev => ({ ...prev, modalNotas: { show: false, cliente: null, deliveries: [] } }))
      },

      onModalEtiquetasClose() {
        setState(prev => ({
          ...prev,
          modalEtiquetas: { show: false, cliente: null, etiquetas: [] },
        }))
      },

      async onBtnExportarClick(selectedTp) {
        if (!Number(selectedTp)) {
          setState(prev => ({ ...prev, errorMessage: SELECT_TP_MESSAGE }))
          return
        }

        setState(prev => ({ ...prev, loadingMessage: 'Exportando relatório...' }))

        EstoqueHttp.getRelatorioPosicoesEtiquetasClienteExcel(selectedTp)
          .then(rows => {
            if (!rows.length) {
              setState(prev => ({
                ...prev,
                loadingMessage: null,
                errorMessage: 'Não existem dados para exportar',
              }))
              return
            }

            const excelData = [
              ['Cliente', 'CNPJ', 'NF', 'Etiqueta', 'Estoque', 'Posição de Estoque'],
            ]

            rows.forEach(row => {
              excelData.push([
                row.cliente,
                row.cnpj,
                row.nf,
                row.etiqueta,
                row.estoque,
                row.posicao_estoque,
              ])
            })

            gerarArquivoExcel(
              'Etiquetas por Cliente',
              excelData,
              'RelatorioPosicoesEtiquetasCliente.xlsx',
            )
            setState(prev => ({ ...prev, loadingMessage: null }))
          })
          .catch(error =>
            setState(prev => ({
              ...prev,
              loadingMessage: null,
              errorMessage: errorHandler(error),
            })),
          )
      },
    }
  }, [])

  return { state, localDispatch }
}
